import { ActionPlanItemWithStep } from 'types/ActionPlan';

// Sorts action items by their step ascending so items sharing a step are
// contiguous (the metric detail page groups them under a step header).
// Items without a step sort last. Stable for items sharing a step.
export const sortActionsByStep = (
  actions: ActionPlanItemWithStep[],
): ActionPlanItemWithStep[] =>
  [...actions].sort((a, b) => (a.step ?? Infinity) - (b.step ?? Infinity));
